import { useAuth } from '@/features/auth/use-auth';
import { AccountInfoCard } from '../components/AccountInfoCard';
import { TelegramLinkCard } from '../components/TelegramLinkCard';
import { PayoutAddressesCard } from '../components/PayoutAddressesCard';
import { PreferencesCard } from '../components/PreferencesCard';
import { ProfileHero } from '../components/ProfileHero';
import {
  AchievementsCard,
  GeeCoinCard,
  QuickActionsCard,
  SocialAccountsCard,
} from '../components/SideCards';
import { TrustedSitesCard } from '../components/TrustedSitesCard';
import { useProfile } from '../api';

/**
 * The member's own profile.
 *
 * Two columns above `lg`, one below, and the order of the single column is the
 * order of the two read top to bottom: who you are, then the two things this
 * site actually needs from you — the site IDs that put your name on a
 * leaderboard, and the address a prize is sent to — then everything else.
 */
export function ProfilePage() {
  const { user } = useAuth();
  const { data, isLoading } = useProfile();

  // The context copy is updated the moment a mutation returns, so it is the
  // fresher of the two until the query refetches.
  const profile = user ?? data;

  if (isLoading && !profile) {
    return (
      <p className="py-20 text-center text-surface-500" role="status">
        Yükleniyor…
      </p>
    );
  }

  if (!profile) {
    return null;
  }

  return (
    <div className="w-full py-2">
      <div className="grid gap-5 lg:grid-cols-[minmax(0,1.7fr)_minmax(0,1fr)]">
        <div className="flex flex-col gap-5">
          <ProfileHero profile={profile} />
          <TrustedSitesCard />
          <PayoutAddressesCard />
          <PreferencesCard profile={profile} />
          <AchievementsCard />
        </div>

        <div className="flex flex-col gap-5">
          <GeeCoinCard />
          <AccountInfoCard profile={profile} />
          {/* Only when there is nothing linked. Once it is, the account row
              above shows the handle and this card has no job. */}
          {profile.telegram ? null : <TelegramLinkCard />}
          <SocialAccountsCard profile={profile} />
          <QuickActionsCard />
        </div>
      </div>
    </div>
  );
}
